/**
* 轉換為鉅亨號分類格式
* -----------------
* 新聞類別 | 鉅亨號類別
* -----------------
* 台股 > 台股
* 國際股 > 國際+美股
* 港陸股 > 港股/A股
* 外匯 > 外匯
* 期貨 > 商品期貨
* 房產 > 房產
* 理財 > 理財+基金
* 消費 > 理財
* 區塊鏈 > 區塊鏈
* document: https://cnyesrd.atlassian.net/wiki/spaces/PS/pages/748683385
*
* 改版對應的新聞分類: https://cnyesrd.atlassian.net/wiki/spaces/PS/pages/2143387649?focusedCommentId=2256535561
*/
export const haoCategoryMapping = (newsCategoryId: number) => {
  switch (newsCategoryId) {
    case 826: // 台股
    case 827: // 台股新聞
    case 828: // 台灣政經
    case 829: // 台股盤勢
    case 862: // 台股表格
    case 863: // 三大法人
    case 864: // 融資券
    case 865: // 其他表格
    case 866: // 表一表八
    case 867: // 公告
    case 868: // 台股公告
    case 869: // 興櫃公告
    case 884: // 台指期貨市場
    case 891: // 台股研報
    case 899: // 專家觀點
    case 901: // 投資工具
    case 907: // 台股盤中
    case 908: // 台股盤前
    case 910: // 台股盤後
    case 911: // 台股預估
    case 916: // 營收速報
      return '台股';
    case 877: // 研究報告
    case 879: // 產業研究
    case 880: // 個股研究
    case 881: // 證券市場
    case 882: // 債券市場
    case 888: // 股票
      return '台股+國際';
    case 830: // 美股
    case 831: // 美股雷達
    case 832: // 歐亞股
    case 833: // 國際政經
    case 912: // 美股盤中
      return '國際+美股';
    case 897: // 美股雷達(下架)
      return '美股';
    case 892: // 國際股研報
    case 900: // cnPOST
      return '國際';
    case 834: // A股港股
    case 835: // A股
    case 836: // 港股
    case 837: // 大陸政經
    case 902: // 新股上市
    case 903: // 權證
    case 904: // 大行報告
    case 905: // 香港政經
      return 'A股+港股';
    case 838: // 外匯
    case 885: // 外匯市場
    case 893: // 外匯研報
      return '外匯';
    case 839: // 期貨
    case 840: // 黃金
    case 841: // 能源
    case 842: // 農作
    case 843: // 原物料
    case 845: // 債券
    case 883: // 期貨市場
    case 887: // 指數
      return '商品期貨';
    case 846: // 房產
    case 847: // 台灣房市
    case 848: // 大陸房市
    case 849: // 香港房市
    case 850: // 海外房市
      return '房產';
    case 851: // 理財
    case 852: // 基金
    case 853: // 消費
    case 854: // 保險
    case 871: // 晨星專欄(下架)
    case 872: // 雜誌
      return '理財+基金';
    case 886: // 基金研報
      return '基金';
    case 873: // 區塊鏈
    case 875: // 區塊鏈應用
    case 876: // 虛擬貨幣
    case 894: // 鏈文
    case 895: // 快訊
    case 896: // 幣圈
    case 898: // 新手村
      return '區塊鏈';
    case 856: // 科技
    case 909: // 虛擬貨幣盤中
      return '科技';
    default:
      return '台股';
  }
};
